enum AtomChirality {
    Invalid = 0,
    Right = -1,
    S = -1,
    Sinister = -1,
    CounterClockwise = -1,
    Left = 1,
    R = 1,
    Rectus = 1,
    Clockwise = 1
}

export default AtomChirality;